/**
 * @generated SignedSource<<6f954b7bf60f4416dced92acb9e79160>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
export type OrderStatusType = "ClosedByAdmin" | "HasBillingDetails" | "HasCart" | "HasPaymentDetails" | "PaymentInProcess" | "PaymentReceived" | "Purchased" | "PurchasedAwaitingAccount" | "Transient";
export type PaymentMethodType = "Card" | "Giropay" | "IapApple" | "IapGoogle" | "InvoicePartner" | "InvoiceTk" | "Klarna" | "MonthlyPartner" | "MonthlyTk" | "Paypal" | "Sepa" | "Sofort";
export type SelectedPaymentMethodKind = "Monthly" | "OneTime";
import { FragmentRefs } from "relay-runtime";
export type ordersTable_OrderFragment$data = {
  readonly createdAt: string;
  readonly id: string;
  readonly purchaser: {
    readonly accountId: string;
    readonly userId: string;
  } | null;
  readonly selectedPaymentMethod: {
    readonly kind: SelectedPaymentMethodKind;
    readonly paymentMethodType: PaymentMethodType;
  } | null;
  readonly startedAsGuest: boolean | null;
  readonly status: OrderStatusType;
  readonly " $fragmentSpreads": FragmentRefs<"orderPriceDisplay_OrderFragment" | "paymentProviderLink_OrderFragment">;
  readonly " $fragmentType": "ordersTable_OrderFragment";
};
export type ordersTable_OrderFragment$key = {
  readonly " $data"?: ordersTable_OrderFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ordersTable_OrderFragment">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "ordersTable_OrderFragment"
};

(node as any).hash = "c76b7a70165fb25ee286a3297e21eac7";

export default node;
